import { ReactElement } from 'react';
import { noop } from 'lodash';

import { VisitAndAppointmentView } from '@dreryk/egabinet-visit-frontend-api';

import { TranslatableText } from '@dreryk/react-common';
import { Dropdown } from '@dreryk/react-components';

import {
   VisitCancelNotConfirmedModalOpener,
   VisitCancelShowModalEventInterceptor,
} from '~libs.desktop.shared.visit-cancel';

import { RefetchAppointments } from '../../../appointments.types';

type AppointmentCancelDropdownItemProps = {
   readonly appointmentId: VisitAndAppointmentView['appointmentId'];
   readonly refetchAppointments: RefetchAppointments;
   readonly label: TranslatableText;
   readonly disabled: boolean;
   readonly timeSlotConfirmed: boolean;
};
export const AppointmentCancelDropdownItem = (props: AppointmentCancelDropdownItemProps): ReactElement => {
   if (props.timeSlotConfirmed) {
      return (
         <VisitCancelShowModalEventInterceptor
            cancellable={!props.disabled}
            appointmentId={props.appointmentId}
            onSuccess={props.refetchAppointments}
            onFault={props.refetchAppointments}
         >
            <Dropdown.Item
               testId={`appointmentCancelOption${props.appointmentId}`}
               onClick={noop}
               disabled={props.disabled}
            >
               {props.label}
            </Dropdown.Item>
         </VisitCancelShowModalEventInterceptor>
      );
   }
   return (
      <VisitCancelNotConfirmedModalOpener appointmentId={props.appointmentId} onSuccess={props.refetchAppointments}>
         {({ openModal }) => (
            <Dropdown.Item
               testId={`appointmentCancelOption${props.appointmentId}`}
               onClick={openModal}
               disabled={props.disabled}
            >
               {props.label}
            </Dropdown.Item>
         )}
      </VisitCancelNotConfirmedModalOpener>
   );
};
